import { TFunction } from 'i18next';
import { FormChecklistTemplate } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type ActionsMenuArgs = {
  onDelete: (v?: FormChecklistTemplate) => void;
  onEdit: (v?: FormChecklistTemplate) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableActionsMenu({
  onDelete,
  onEdit,
  t,
}: ActionsMenuArgs): NavItem<FormChecklistTemplate>[] {
  return [
    {
      id: 'edit',
      title: t('edit'),
      onClick: (item?: FormChecklistTemplate) => onEdit(item),
      leftIcon: Icons.edit,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'delete',
      title: t('delete'),
      onClick: (item?: FormChecklistTemplate) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
    },
  ];
}
